@if (
  selectedResource()?.completedResourceResponse?.completedDate;
  as completedDate
) {
  <gc-tooltip
    [text]="
      ('resource.tooltip' | translate) +
      (completedDate | date: 'yyyy-MM-dd HH:mm')
    "
    [position]="'bottom'"
  >
    <gc-icon [iconName]="'circleCheck'" [color]="'success'" [size]="'medium'" />
  </gc-tooltip>
}
